import * as React from "react";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { GridCellProps } from "@progress/kendo-react-grid";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { checkAvailability, checkContractType, checkFunctionality, checkPriority, checkWorkType, getMilliSec, getMilliSecUTC } from "../../utils/EllowUtils";
import { updateAllocationPosition, updateAllocationResource, updateAvailablity, updatePriority , updateInvoiceRaised } from "./services";
import classnames from "classnames";
import { useEffect } from "react";
import mixpanelData, { userProfile } from "../../utils/mixpanel";


export const DropDown = (props: GridCellProps, getTableValues?: any, dateChange?:any, weekChange?:any) => {

 
  const userLoginId = localStorage.getItem('loginId')
  const { dataItem } = props;
  const field = props.field || '';
  let newDate = new Date() 
  const dataValue = dataItem[field] === null ? '' : dataItem[field];  

  const selectDropdown = (fieldName: string) => {    
    let valueData = [];
    
    switch (fieldName) {
      case "availabilityValue":
        return (valueData = CONSTANTS.localizedData);
      
      case "priority":
        return (valueData = CONSTANTS.localizedData3);
        
      case "invoiceRaisedStatus":
        return (valueData = CONSTANTS.localizedData4);

      case "job_priority":
        return (valueData = CONSTANTS.localizedData3);
      
      default:
        return(valueData = CONSTANTS.localizedData2)
    }
  };


  const handleChange = (e: DropDownListChangeEvent) => {
     
    if (field === 'availabilityValue') {
     
      if (e.target.value.value === 2) {
        dateChange()
        
      }
      else if (e.target.value.value === 3) {
       // setWeek(true)
        weekChange()
      }
      else {
        if (e.target.value.value === 1) {
          
          let value = {
            "loginId": props.dataItem.loginId,
            "availability": {
              "date": 0,
              "weeks":0,
              "availabilityId": 1,
              "lastUpdateDate": getMilliSecUTC(newDate),
            },
            "userLoginId": userLoginId,
            "submittedBy": 'RECRUITER'
          }
          updateAvailablity(value).then((response) => {
            if (response && response.status === 1) {
              mixpanelData('New TG - Avaialblity Updated', {
                'source': 'Recruiter updates availability of a candidate from resource Table',
                'distinct_id': localStorage.getItem('Email'),
                'Candidate loginid': props.dataItem.loginId,
                'Candidate email': props.dataItem.email,
                'Candidate name': props.dataItem.firstName + " " + props.dataItem.lastName,
                'Contract type': checkContractType(parseInt(props.dataItem.contractType)),
                'Work type': checkWorkType(parseInt(props.dataItem.work_type)),
                'Availability': 'Immediately'
              })
              userProfile({
                'Contract type': checkContractType(parseInt(response.data.contractType)),
                'Work type': checkWorkType(parseInt(response.data.work_type)),
                'Availability': 'Immediately'
              }, props.dataItem.loginId)
              getTableValues();
            }
          })
        } else {
          let value = {
            "loginId": props.dataItem.loginId,
            "availability": {
              "date": 0,
              "weeks":0,
              "availabilityId": e.target.value.value,
              "lastUpdateDate": getMilliSecUTC(newDate),
            },
            "userLoginId": userLoginId,
            "submittedBy": 'RECRUITER'
          }
          updateAvailablity(value).then((response) => {
            if (response && response.status === 1) {
              mixpanelData('New TG - Avaialblity Updated', {
                'source': 'Recruiter updates availability of a candidate from resource Table',
                'distinct_id': localStorage.getItem('Email'),
                'Candidate loginid': props.dataItem.loginId,
                'Candidate email': props.dataItem.email,
                'Candidate name': props.dataItem.firstName + " " + props.dataItem.lastName,
                'Contract type': checkContractType(parseInt(props.dataItem.contractType)),
                'Work type': checkWorkType(parseInt(props.dataItem.workType)),
                'Availability': checkAvailability(e.target.value.value)
              })
              userProfile({
                'Contract type': checkContractType(parseInt(response.data.contractType)),
                'Work type': checkWorkType(parseInt(response.data.work_type)),
                'Availability': checkAvailability(e.target.value.value)
              }, props.dataItem.loginId)
              getTableValues();
            }
          })
        }
      }
     
    }
     
    if (field === 'priority') {

    let value =  {
        "jobId":props.dataItem.jobId,
        "userLoginId":userLoginId,
        "jobMetadata":{
        "priority": e.target.value.value
    }
    }   
    
      updatePriority(value).then((response) => {
        if(response && response.status === 1){
          mixpanelData('TG-Position Priority Updated', {
            'source': "Recruiter changed the Priority",
            'allocatedTo': e.target.value.name,
            'positionName': props.dataItem.positionName,
            'email': localStorage.getItem('Email'),
            'Priority': e.target.value.text,
            'distinct_id': localStorage.getItem('Email'),
          })  
          mixpanelData('New TG - Position Priority Updated', {
            'Source': "Recruiter changed the Priority",
            'Allocated To': props.dataItem.allocated_to ? props.dataItem.allocated_to : 'Not Mentioned',
            'Position Name': props.dataItem.positionName,
            'Priority': e.target.value.text,
            'distinct_id': localStorage.getItem('Email'),
            'Company': props.dataItem.company,
            'Job Id': props.dataItem.jobId
          })   
          getTableValues();
        }
      })
    }

    if (field === 'invoiceRaisedStatus') {
      let value = {
        "timesheetId": props.dataItem.timesheetId,
        "status": e.target.value.text === 'Yes' ? true : false
      }
      updateInvoiceRaised(value).then((response) => {
        if(response && response.status === 1){
          getTableValues()
        }
      })
    }

    if (props.onChange && field !== 'allocatedTo') {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };

  const checkPriorityColour = (name: string, data: any) => {
   let value = checkFunctionality(field, dataValue)
   switch (value){
     case 'Hot':
       return 'Red'
     case 'Warm':
       return 'Yellow'
     case 'Cold':
       return 'Blue'
     default: 
       return 'Blue'
   }
  }

  let currentDate = new Date().getTime()
  let dateOfRegistration = props.dataItem.createdDate
  var diff =(currentDate -  dateOfRegistration) / 1000;
  diff /= (60 * 60);
  let diff2 = Math.abs(Math.round(diff));
    
  return (
      <td  className="statusWrap">
        {diff2 <= 24 &&
          <span className="userStatus">New</span>
        }
        { dataItem && dataItem.inEdit ? (
          <DropDownList
            style={{ width: "100%" }}
            onChange={handleChange}
            value={selectDropdown(field).find((c: { value: any; }) => c.value === dataValue)}
            data={selectDropdown(field)}
            textField="text"
                />
            ) : (
              
          field !== 'priority' ? 
          ( field === 'invoiceRaisedStatus' ? <div className="wordBreak">{dataValue}</div> : <div className="wordBreak">{dataValue && checkFunctionality(field, dataValue)}</div>) : 
          <div className={classnames(checkPriorityColour(field, dataValue,) + " statusMessage")}>{dataValue && checkFunctionality(field, dataValue)}</div>
          )
          }
      </td>
    );
}

